import React from 'react';
import {Helmet} from 'react-helmet';
import Layout from '../common/Layout';
import LayoutContentContainer from '../common/LayoutContentContainer';

const GenericContentPage = (props) => {
    return <Layout navSecondaryShow={true} className="bg-light" contentBackgroundArt={true}>
        <Helmet><title>{props.headTitle}</title></Helmet>
        <LayoutContentContainer>
            <h1
                style={
                    {
                        fontWeight: 400
                    }
                }
            >
                {
                    props.title
                }
            </h1>
            <div
                style={
                    {
                        marginTop: '2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '5rem'
                    }
                }
            >
            {
                props.children
            }
            </div>
        </LayoutContentContainer>
    </Layout>
}

export default GenericContentPage;
